module.exports = __webpack_public_path__ + "static/nag-me.7c04e4a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nag-me.jpg
// module id = 70
// module chunks = 35783957827783 43424109361899 213720915766396